export function parseConsecutiveTemplateSlots(body: string): {
  count: number;
  valid: boolean;
  gaps: number[];
} {
  const matches = Array.from(String(body || '').matchAll(/\{\{(\d+)\}\}/g)).map((m) =>
    Number(m[1])
  );
  if (!matches.length) {
    return { count: 0, valid: true, gaps: [] };
  }

  const found = Array.from(new Set(matches)).sort((a, b) => a - b);
  const maxSlot = found[found.length - 1];
  const gaps: number[] = [];
  for (let slot = 1; slot <= maxSlot; slot += 1) {
    if (!found.includes(slot)) gaps.push(slot);
  }

  return {
    count: maxSlot,
    valid: gaps.length === 0 && found.length === maxSlot,
    gaps,
  };
}

export function slotValidationMessage(body: string): string | null {
  const parsed = parseConsecutiveTemplateSlots(body);
  if (parsed.count === 0) return null;
  if (parsed.valid) return null;
  return `Body must use consecutive placeholders {{1}} through {{${parsed.count}}} — missing: ${parsed.gaps.map((g) => `{{${g}}}`).join(', ')}`;
}
